// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import SalesPromotion, { STATES } from 'common/modules/sales/domain/SalesPromotion';
import Page from 'common/components/Page';
import type { SalesPromotionState } from 'common/modules/sales/domain/SalesPromotion';
import LoadingSpinner from 'common/components/LoadingSpinner';
import SalesPromotionTable from './components/SalesPromotionTable';
import TabPicker from '../../components/TabPicker';
import type { TabEntry } from '../../components/TabPicker';
import MessageCard from '../../components/MessageCard';
import CreatePromotionDialog from './CreatePromotionDialog';
import { getPromotionState } from './selectors/promotionSelectors';
import { fetchPromotions } from './actions/promotionActions';
import type { PromotionState } from './reducers/promotionReducer';


const SRaisedButton = styled(RaisedButton)`
  margin-bottom: ${({ theme }) => theme.metrics.largeMargin}px;
`;

const TabPickerWrapper = styled.div`
  width: 30%;
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

type Props = {
  t: any;
  theme: Object;
  promotion: PromotionState;

  actions: {
    fetchPromotions: () => any;
  }
}

type State = {
  createPromotionDialogOpen: boolean;
  tabFilter: SalesPromotionState;
}

class SalesPromotionPage extends React.Component<Props, State> {

  constructor(props) {
    super(props);

    this.state = {
      createPromotionDialogOpen: false,
      tabFilter: 'PROPOSED',
    };
  }

  componentWillMount() {
    this.props.actions.fetchPromotions();
  }

  onOpenDialog = () => {
    this.setState({ createPromotionDialogOpen: true });
  }

  onCloseDialog = () => {
    this.setState({ createPromotionDialogOpen: false });
  }

  onChangeTabFilter = (filter: SalesPromotionState) => {
    this.setState({ tabFilter: filter });
  }

  getFilteredPrommotions = (): SalesPromotion[] => {
    return this.props.promotion.promotions.filter(p => p.isInState(this.state.tabFilter));
  }

  generatePromotionFilters = (): TabEntry[] => {
    return STATES.map(state => ({ value: state, label: this.props.t(state.toLowerCase()) }));
  }

  render() {
    const { t, theme, promotion } = this.props;
    const { createPromotionDialogOpen, tabFilter } = this.state;
    const { fetching, fetchingError } = promotion;
    const filteredPromotions = this.getFilteredPrommotions();
    const hasPromotions = filteredPromotions.length > 0;

    return (
      <Page title={t('salesPromotions')}>
        {!fetching && fetchingError && <MessageCard message={t('promotionLoadingError')} />}
        {fetching && <LoadingSpinner size="medium" />}
        {!fetching && !fetchingError &&
          <div>
            <SRaisedButton primary labelStyle={{ fontSize: theme.fonts.style.small.fontSize }} label={t('newPromotion')} onClick={this.onOpenDialog} />
            <TabPickerWrapper>
              <TabPicker
                tabs={this.generatePromotionFilters()}
                currentTab={tabFilter}
                onChangeTab={this.onChangeTabFilter}
              />
            </TabPickerWrapper>
            {hasPromotions && <SalesPromotionTable salesPromotions={filteredPromotions} />}
            {!fetching && !hasPromotions && <MessageCard message={t('hasNoPromotionsInState')} />}
          </div>
        }
        <CreatePromotionDialog onClose={this.onCloseDialog} visible={createPromotionDialogOpen} />
      </Page>
    );
  }
}

function mapStateToProps(state: Object) {
  return {
    promotion: getPromotionState(state),
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ fetchPromotions }, dispatch),
  };
}

export default compose(withTheme, connect(mapStateToProps, mapDispatchToProps), translate('promotion'))(SalesPromotionPage);



// WEBPACK FOOTER //
// ./src/statsradio/modules/promotions/SalesPromotionPage.js